<script setup lang="ts">
import { getIrisComponent } from "@/Iris/Composables/getIrisComponents";
import { routeType } from "@/types/route";
import { inject, provide, computed, ref, onErrorCaptured } from "vue";
import { notify } from "@kyvg/vue3-notification";
import { ctrans } from "@/Composables/useTrans"
import axios from "axios";
import MobileHeader from "@/Components/CMS/Website/Headers/MobileHeader.vue";
import { getStyles } from "@/Composables/styles";
import { router } from "@inertiajs/vue3"
import { clearIrisSession } from "@/Composables/clearIrisSession"

const props = defineProps<{
  data: {
    key: string,
    data: object,
    blueprint: object
    loginRoute?: routeType
  }
  menu: {
    key: string,
    data: object,
    blueprint: object
  }
  colorThemed: object
  screenType?: "mobile" | "tablet" | "desktop"
  customSidebar?:any
}>();


const layout = inject("layout", {});
const isLoggedIn = computed(() => {
  return layout.iris?.is_logged_in;
})
provide("isPreviewLoggedIn", isLoggedIn);

const isLoadingLogout = ref(false)
let restoreIrisSession: (() => void) | null = null
const onClickLogout = () => {
    router.post(
        '/app/logout',
        {
            
        },
        {
            preserveScroll: true,
            preserveState: true,
            onStart: () => {
                isLoadingLogout.value = true
                restoreIrisSession = clearIrisSession(layout)
            },
            onError: errors => {
                restoreIrisSession?.()
                notify({
                    title: ctrans("Something went wrong"),
                    text: ctrans("Failed to logout"),
                    type: "error"
                })
            },
            onFinish: () => {
                isLoadingLogout.value = false
            },
        }
    )
}


provide("onLogout", onClickLogout);

onErrorCaptured((error, _instance, info) => {
    const blockCode = (props.data as any)?.header?.code;

    console.error(
        `[IrisHeader] header block "${blockCode}" failed to render (${info}):`,
        error
    );

    import("@sentry/vue").then(({ captureException }) => {
        captureException(error, {
            tags: {
                area: "iris-header",
                header_block: blockCode,
            },
            contexts: {
                vue: {
                    lifecycleHook: info,
                    headerBlock: blockCode,
                },
            },
        });
    });

    return false;
});

</script>

<template>
  <!-- Section: Topbar (login, logout) -->
  <component
    v-if="data?.topBar?.data.fieldValue" :is="getIrisComponent(data?.topBar.code)"
    :fieldValue="data.topBar.data.fieldValue" v-model="data.topBar.data.fieldValue"
    class="iris-topbar-reserve"
   />

  <!-- Section: Header (logo, search, Title) -->
  <component v-if="data?.header" :is="getIrisComponent(data?.header?.code)" :fieldValue="data.header.data.fieldValue" class="hidden md:block" />

  <!-- Section: Menu desktop -->
  <component v-if="menu?.code" :is="getIrisComponent(menu?.code)" :fieldValue="menu?.data?.fieldValue"
             :colorThemed="colorThemed" class="hidden md:block" />

  <!-- Section: Mobile Header -->
  <div :style="getStyles(data.header.data.fieldValue.container.properties, screenType)" class="sticky top-0 z-50">
      <MobileHeader :header-data="data.header.data.fieldValue" :menu-data="menu?.data?.fieldValue" :productCategories="menu?.product_categories ?? []" :screenType="screenType" />
  </div>

</template>

<style scoped>
.iris-topbar-reserve {
  min-height: 2.25rem;
}
</style>